import { useQuery } from '@tanstack/react-query';
import apiService from '../services/api';
import type { DeliveryPricingResponse } from '../utils/deliveryPricing';

export type DeliveryPricingQueryParams = {
  conversationId?: number;
  locationProviderId?: number;
};

export function deliveryPricingQueryKey(params?: DeliveryPricingQueryParams) {
  if (params?.conversationId) {
    return ['delivery-pricing', { conversationId: params.conversationId }] as const;
  }
  if (params?.locationProviderId) {
    return ['delivery-pricing', { locationProviderId: params.locationProviderId }] as const;
  }
  return ['delivery-pricing'] as const;
}

export function useDeliveryPricing(params?: DeliveryPricingQueryParams) {
  return useQuery<DeliveryPricingResponse>({
    queryKey: deliveryPricingQueryKey(params),
    queryFn: () =>
      apiService.getDeliveryPricing({
        conversationId: params?.conversationId,
        locationProviderId: params?.locationProviderId,
      }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
